<template>
      <div
        class="d-flex flex-column px-2"
        style="min-width: 135px; max-width: 135px;"
      >
      <div>
        <span class="text-body-1 text--secondary mr-1 text-no-wrap">
          {{ $t('toolbar.avgPtax') }}
        </span>

        <v-tooltip v-if="!this.getFxMarketAvgPtax && !this.isBefore10AM && !this.isAfter6PM" right
        content-class="ptax-tooltip"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mb-1" v-bind="attrs" v-on="on" x-small>mdi-information</v-icon>
          </template>
          <span> {{ $t('toolbar.avgPtaxTooltipNoData') }} </span>
        </v-tooltip>

        <v-tooltip v-else right
          content-class="ptax-tooltip"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mb-1" v-bind="attrs" v-on="on" x-small>mdi-information</v-icon>
          </template>
          <span> {{ $t('toolbar.avgPtaxDescription') }} </span>
        </v-tooltip>
      </div>

        <span :style="{ '--news-font-size': fontsSetting.getFontSize * '30' + 'px' }" class="avg-title">
          {{ avgPtax }}
        </span>
    </div>
</template>

<script>
import { mapState } from "pinia"
import { useSettingsStore } from "./../store/index"
import { useFxMarketStore } from "@/store/toolbarStore";

export default {
  data () {
    return {
      fontsSetting: useSettingsStore(),
    }
  },
  mounted () {
  },
  methods: {
  },
  computed: {
    ...mapState(useFxMarketStore, [
      "getFxMarketAvgPtax"
    ]),
    avgPtax () {
      const avg = JSON.parse(localStorage.getItem('avgPtax'))
      if (!avg || avg.length === 0) return 'N/A'
      if (!this.getFxMarketAvgPtax) return avg[avg.length - 1].avg_ptax.toFixed(4)

      const val =
        this.getFxMarketAvgPtax?.length
          ? this.getFxMarketAvgPtax[this.getFxMarketAvgPtax.length - 1]?.avg_ptax
          : avg[avg.length - 1]?.avg_ptax

      return typeof val === 'number' ? val.toFixed(4) : ''
    },
    isBefore10AM() {
      const now = new Date()
      const limit = new Date()
      limit.setHours(10)
      limit.setMinutes(5)
      limit.setSeconds(0)
      return now < limit
    },
    isAfter6PM() {
      const now = new Date()
      const limit = new Date()
      limit.setHours(18)
      limit.setMinutes(15)
      limit.setSeconds(0)
      return now > limit
    }
  }
}
</script>

<style scoped>
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 10
}

.ptax-tooltip {
  margin-top: 80px;
  max-width: 250px;
  white-space: normal;
  word-break: break-word;
  text-align: justify;
  color: #ffffff;
  background-color: #1b1b1b;
}

.avg-title{
  font-size: var(--news-font-size) !important;
  font-weight: bolder !important;
  line-height: 1.5rem;
  margin-top:.7rem;
}
</style>